import React, { FC, useEffect } from 'react';
import { DialogButton, DialogContent, DialogWrapper } from './styled';

interface IProps {
  handlerClose: () => void;
  maxWidth: string;
  persistence?: boolean;
  show: boolean;
  zIndex: number;
}

const Dialog: FC<IProps> = ({
  children,
  handlerClose,
  maxWidth,
  persistence,
  show,
  zIndex
}) => {
  useEffect(() => {
    const body = document.querySelector('body');

    if (body) {
      if (show) body.style.overflow = 'hidden';
      else body.style.overflow = '';
    }
  }, [show]);

  const closeController = (locked: boolean) => {
    if (locked && persistence) return;
    handlerClose();
  };

  return (
    <DialogWrapper
      data-testid="cmp-dialog-wrapper"
      show={show}
      zIndex={zIndex}
      onClick={() => closeController(true)}
    >
      <DialogContent
        data-testid="cmp-dialog-content"
        show={show}
        maxWidth={maxWidth}
        onClick={(e) => e.stopPropagation()}
      >
        <DialogButton
          data-testid="cmp-dialog-button"
          onClick={() => closeController(false)}
        />
        {show ? children : ''}
      </DialogContent>
    </DialogWrapper>
  );
};

export default Dialog;
